// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#clear-function-argument-btn:focus{margin-right:16px}", "",{"version":3,"sources":["webpack://./src/CqlBuilderPanel/functionsSection/argumentSection/ArguementsSection.scss"],"names":[],"mappings":"AACE,mCACE,iBAAA","sourcesContent":["#clear-function-argument-btn {\n  &:focus {\n    margin-right: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
